<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
    Loading trip details...
  </div>
  
  <div class="main-wrapper" *ngIf="!isLoading">
    <div class="page-wrapper">
      <div class="content">
        <div class="trip-view-content">
  
          <!-- Title Row -->
          <div class="order-title-row">
            <div>
              <h4 class="order-title">{{ order?.orderNumber }} &mdash; {{ order?.customerName }}</h4>
              <div class="order-subtitle" *ngIf="order?.source || order?.destination">
                {{ order?.source }} - {{ order?.destination }}
              </div>
            </div>
            <div class="title-actions">
              <span class="badge mode-badge" *ngIf="isReadOnly">🔒 Read Only</span>
              <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 1: Arrival Details
          ══════════════════════════════════════ -->
  
          <!-- Editable version: END_TRIP / ADD_POD -->
          <div class="card-section" *ngIf="!isReadOnly">
            <div class="section-header">
              <span class="step-badge">1</span>
              <h5>Arrival Details</h5>
            </div>
  
            <div class="section-body">
              <div class="form-grid">
                <div class="form-field">
                  <label>Reporting Date &amp; Time <span class="required">*</span></label>
                  <input
                    type="datetime-local"
                    class="form-control editable"
                    [class.is-invalid]="arrivalDateError"
                    [(ngModel)]="arrivalReportingDateTime"
                    (ngModelChange)="onArrivalDateTimeChange()" />
                </div>
              
                <div class="form-field">
                  <label>Unloading Date &amp; Time <span class="required">*</span></label>
                  <input
                    type="datetime-local"
                    class="form-control editable"
                    [class.is-invalid]="arrivalDateError"
                    [(ngModel)]="arrivalUnloadingDateTime"
                    (ngModelChange)="onArrivalDateTimeChange()" />
                </div>
              </div>
              
              <!-- Validation error -->
              <div class="text-danger validation-msg" *ngIf="arrivalDateError">
                ⚠️ {{ arrivalDateError }}
              </div>
              
              <!-- Days calculation banner — only when valid -->
              <div class="red-info-banner" [ngClass]="{'green-info-banner': tripDaysLabel === 'Same day delivery'}"
                   *ngIf="arrivalReportingDateTime && arrivalUnloadingDateTime && !arrivalDateError">
                🕐 {{ tripDaysLabel }}
              </div>
            </div>
          </div>
  
          <!-- Read-only version: SHOW_POD -->
          <div class="card-section" *ngIf="isReadOnly">
            <div class="section-header">
              <span class="step-badge">1</span>
              <h5>Arrival Details</h5>
              <span class="read-only-badge">🔒 Read only</span>
            </div>
  
            <div class="section-body">
              <div class="form-grid">
                <div class="form-field">
                  <label>Reporting Date &amp; Time</label>
                  <input type="text" class="form-control" [value]="formatApiDate(tripData?.reportingDateTime)" readonly />
                </div>
                <div class="form-field">
                  <label>Unloading Date &amp; Time</label>
                  <input type="text" class="form-control" [value]="formatApiDate(tripData?.loadingDateTime)" readonly />
                </div>
              </div>
              <div class="red-info-banner" [ngClass]="{'green-info-banner': tripDaysLabel === 'Same day delivery'}" *ngIf="arrivalReportingDateTime && arrivalUnloadingDateTime">
                🕐 {{ tripDaysLabel }}
              </div>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 2: POD Details
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header">
              <span class="step-badge">2</span>
              <h5>POD Details</h5>
              <span class="read-only-badge" *ngIf="isReadOnly">🔒 Read only</span>
            </div>
  
            <div class="section-body">
  
              <!-- Saved PODs — compact cards, shown in every mode -->
              <div class="info-banner" *ngIf="savedPods.length === 0 && !savedPodsLoading">
                📬 No PODs saved yet<span *ngIf="!isReadOnly">. Add one below.</span>
              </div>
  
              <div class="pod-cards-grid" *ngIf="savedPods.length > 0">
                <div
                  class="pod-card"
                  [ngClass]="pod.podType === 'Soft' ? 'pod-card-soft' : 'pod-card-hard'"
                  *ngFor="let pod of savedPods">
  
                  <div class="pod-card-header">
                    <span class="pod-card-title">
                      <span class="pod-type-icon">{{ pod.podType === 'Soft' ? '📄' : '📦' }}</span>
                      {{ pod.podType }} POD
                    </span>
                    <span class="badge" [ngClass]="podStatusClass(pod.status)">{{ pod.status }}</span>
                  </div>
  
                  <div class="pod-card-body">
                    <div class="pod-card-row">
                      <span class="pod-card-label">Date</span>
                      <span class="pod-card-value">{{ formatApiDate(pod.podDate || pod.createdAt) }}</span>
                    </div>
  
                    <div class="pod-card-row" *ngIf="pod.podType === 'Soft'">
                      <span class="pod-card-label">Condition</span>
                      <span class="pod-card-value">{{ pod.isClean === 1 ? '✅ Clean' : '⚠️ Remark' }}</span>
                    </div>
  
                    <div class="pod-card-row" *ngIf="pod.modeId">
                      <span class="pod-card-label">Mode</span>
                      <span class="pod-card-value">{{ modeName(pod.modeId) }}</span>
                    </div>
                    <div class="pod-card-row" *ngIf="pod.trackingId">
                        <span class="pod-card-label">Tracking Id</span>
                        <span class="pod-card-value">{{ pod.trackingId }}</span>
                      </div>
                  </div>
  
                  <div class="pod-card-footer">
                    <a class="doc-link-icon" *ngIf="pod.podUrl" [href]="pod.podUrl" target="_blank" rel="noopener" title="View document">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                      </svg>
                    </a>
                    <span class="pod-doc-empty" *ngIf="!pod.podUrl" title="No document">🚫</span>
                  
                    <button
                      type="button"
                      class="pod-edit-btn"
                      *ngIf="!isReadOnly"
                      (click)="pod.podType === 'Soft' ? editSoftPod(pod) : editHardPod(pod)"
                      title="Edit">
                      ✏️
                    </button>
                  
                    <button
                      type="button"
                      class="pod-remarks-toggle"
                      *ngIf="pod.lineItems?.length"
                      (click)="pod.expanded = !pod.expanded">
                      {{ pod.expanded ? 'Hide' : 'View' }} Remarks ({{ pod.lineItems.length }})
                    </button>
                  </div>
  
                  <div class="pod-card-remarks" *ngIf="pod.expanded && pod.lineItems?.length">
                    <div class="pod-remark-line" *ngFor="let li of pod.lineItems">
                      <span class="remark-cat">{{ categoryName(li.categoryId) }}</span>
                      <span>Qty: {{ li.quantity }}</span>
                      <span>₹{{ li?.amount  | number:'1.0-0':'en-IN' }}</span>
                      <span *ngIf="li.remarks">— {{ li.remarks }}</span>
                    </div>
                  </div>
  
                </div>
              </div>
  
              <!-- Everything below is the ADD/EDIT flow, laid out as two
                   columns: Soft POD on the left, Hard POD on the right.
                   Hidden entirely in SHOW_POD (read-only) mode — no forms,
                   no upload controls, no save buttons. -->
              <ng-container *ngIf="!isReadOnly">
  
                <div class="pod-form-columns">
  
                  <!-- SOFT COPY POD -->
                  <div class="repeatable-block pod-form-soft" *ngIf="showSoftPodForm">
                    <div class="repeatable-header">
                        <span class="repeatable-title">📄 {{ editingSoftPod ? 'Edit' : '' }} Soft Copy POD</span>
                        <span
                          class="lhc-section-icon cursor-pointer"
                          *ngIf="editingSoftPod"
                          (click)="cancelEditSoftPod()">
                          ❌
                        </span>
                      </div>
  
                    <!-- POD CONDITION -->
                    <div class="repeatable-block" style="background:#fff;">
                      <div class="repeatable-header">
                        <span class="repeatable-title">POD Condition</span>
                      </div>
  
                      <div class="radio-group">
                        <div class="radio-options">
                          <label class="radio-option">
                            <input type="radio" name="podCond" [checked]="podCondition === 'CLEAN'"
                              (change)="podCondition = 'CLEAN'; podRemarks = [emptyRemark()]" />
                            ✅ Clean
                          </label>
                          <label class="radio-option">
                            <input type="radio" name="podCond" [checked]="podCondition === 'REMARK'"
                              (change)="podCondition = 'REMARK'" />
                            ⚠️ Remark
                          </label>
                        </div>
                      </div>
  
                      <!-- Remarks — only when REMARK selected -->
                      <ng-container *ngIf="podCondition === 'REMARK'">
                        <div class="sub-section-header">
                          <span>📝</span>
                          <span>Remarks</span>
                        </div>
  
                        <div class="repeatable-block" *ngFor="let remark of podRemarks; let i = index" style="background:#fcfbff;">
                          <div class="repeatable-header">
                            <span class="repeatable-title">Remark {{ i + 1 }}</span>
                            <span
                              class="lhc-section-icon cursor-pointer"
                              *ngIf="podRemarks.length > 1"
                              (click)="removeRemark(i)">
                              ❌
                            </span>
                          </div>
  
                          <div class="form-grid">
                            <div class="form-field">
                              <label>Category <span class="required">*</span></label>
                              <select class="form-control editable" [(ngModel)]="remark.categoryId">
                                <option [ngValue]="null" disabled>Select category</option>
                                <option *ngFor="let cat of podCategoryList" [ngValue]="cat.id">{{ cat.name || cat.categoryName }}</option>
                              </select>
                            </div>
                            <div class="form-field">
                              <label>Quantity <span class="required">*</span></label>
                              <input type="number" class="form-control editable" [(ngModel)]="remark.quantity" placeholder="0" />
                            </div>
                            <div class="form-field">
                              <label>Amount (₹)</label>
                              <input type="text" appIndianNumberFormat  class="form-control editable" [(ngModel)]="remark.amount" placeholder="0" />
                            </div>
                          </div>
  
                          <div class="form-grid">
                            <div class="form-field full">
                              <label>Comment <span class="optional-label">(optional)</span></label>
                              <textarea class="form-control editable" rows="2" [(ngModel)]="remark.remarks" placeholder="Optional notes..."></textarea>
                            </div>
                          </div>
                        </div>
  
                        <button type="button" class="btn btn-add" (click)="addRemark()">+ Add Another Remark</button>
                      </ng-container>
                    </div>
  
                    <div class="form-grid">
                      <div class="form-field">
                        <label>POD Date <span class="required">*</span></label>
                        <input type="date" class="form-control editable" [(ngModel)]="softPodDate" />
                      </div>
                      <div class="form-field">
                        <label>Upload Document</label>
                        <div class="file-upload-row">
                          <label class="file-upload-btn">
                            📎 Choose File
                            <input type="file" hidden accept="image/*,.pdf" (change)="onSoftPodFileSelected($event)" />
                          </label>
                          <span class="file-upload-status" *ngIf="softPodUploading">Uploading...</span>
                          <span class="file-upload-status success" *ngIf="!softPodUploading && softPodUrl">✓ Uploaded</span>
                          <span class="file-upload-status" *ngIf="!softPodUploading && !softPodUrl">No file chosen</span>
                        </div>
                      </div>
                    </div>
  
                    <div class="row-footer">
                        <button type="button" class="btn btn-purple" [disabled]="podSaving" (click)="savePodDetails()">
                          {{ podSaving ? 'Saving...' : (editingSoftPod ? 'Update Soft POD' : 'Save Soft POD') }}
                        </button>
                      </div>
                  </div>
  
                  <!-- HARD COPY POD -->
                  <div class="repeatable-block pod-form-hard" *ngIf="showHardPodForm">
                    <div class="repeatable-header">
                        <span class="repeatable-title">📦 {{ editingHardPod ? 'Edit' : '' }} Hard Copy POD</span>
                        <span
                          class="lhc-section-icon cursor-pointer"
                          *ngIf="editingHardPod"
                          (click)="cancelEditHardPod()">
                          ❌
                        </span>
                      </div>
  
                    <!-- Tabs: Pending / Received / Lost -->
                    <div class="radio-group">
                      <div class="radio-options">
                        <!-- <label class="radio-option">
                          <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'PENDING'" (change)="hardPodTab = 'PENDING'" />
                          ⏳ Pending
                        </label> -->
                        <label class="radio-option">
                          <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'RECEIVED'" (change)="hardPodTab = 'RECEIVED'" />
                          ✅ Received
                        </label>
                        <label class="radio-option">
                          <input type="radio" name="hardPodTab" [checked]="hardPodTab === 'LOST'" (change)="hardPodTab = 'LOST';indemnityStatus = 'RECEIVED'" />
                          ⚠️ Lost
                        </label>
                      </div>
                    </div>
  
                    <!-- Received -->
                    <div *ngIf="hardPodTab === 'RECEIVED'">
                      <div class="form-grid">
                        <div class="form-field">
                          <label>Mode <span class="required">*</span></label>
                          <select class="form-control editable" [(ngModel)]="hardPodMode" (ngModelChange)="selectMode($event)">
                            <option [ngValue]="null" disabled>Select mode</option>
                            <option *ngFor="let m of podModeList" [ngValue]="m.id">{{ m.name || m.modeName }}</option>
                          </select>
                        </div>
                        <div class="form-field" *ngIf="selectedHardPodMode === 'Courier'">
                            <label>Tracking Id <span class="required">*</span></label>
                            <input type="text" class="form-control editable" [(ngModel)]="trackingId" />
                        </div>
                        <div class="form-field">
                          <label>Submission Date <span class="required">*</span></label>
                          <input type="date" class="form-control editable" [(ngModel)]="hardPodSubmissionDate" />
                        </div>
                      </div>
  
                      <div class="form-grid">
                        <div class="form-field">
                          <label>Upload Hard POD</label>
                          <div class="file-upload-row">
                            <label class="file-upload-btn">
                              📎 Choose File
                              <input type="file" hidden accept="image/*,.pdf" (change)="onHardPodFileSelected($event)" />
                            </label>
                            <span class="file-upload-status" *ngIf="hardPodUploading">Uploading...</span>
                            <span class="file-upload-status success" *ngIf="!hardPodUploading && hardPodUrl">✓ Uploaded</span>
                            <span class="file-upload-status" *ngIf="!hardPodUploading && !hardPodUrl">No file chosen</span>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Lost -->
                    <div *ngIf="hardPodTab === 'LOST'">
                      <div class="info-banner" style="background:#fff1f2; color:#be123c;">
                        ⚠️ <b>Lost POD reported.</b> Indemnity bond required from vendor.
                      </div>
  
                      <div class="radio-group" style="margin-top: 14px;">
                        <label class="radio-label">Indemnity Status <span class="required">*</span></label>
                        <div class="radio-options" style="flex-direction: column; gap: 10px;">
                          <label class="radio-option">
                            <input type="radio" name="indemnity" [checked]="indemnityStatus === 'RECEIVED'" (change)="indemnityStatus = 'RECEIVED'" />
                            Yes — Applicable
                          </label>
                          <!-- <label class="radio-option">
                            <input type="radio" name="indemnity" [checked]="indemnityStatus === 'PENDING'" (change)="indemnityStatus = 'PENDING'" />
                            No / Indemnity Pending — Not yet received from vendor.
                          </label> -->
                        </div>
                      </div>
                    </div>
  
                    <div class="row-footer">
                        <button type="button" class="btn btn-purple" [disabled]="hardPodSaving || hardPodTab === 'PENDING'" (click)="saveHardPod()">
                          {{ hardPodSaving ? 'Saving...' : (editingHardPod ? 'Update Hard POD' : 'Save Hard POD') }}
                        </button>
                      </div>
                  </div>
  
                </div>
  
              </ng-container>
  
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 3: Additional Charges
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header between">
              <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3</span>
                <h5>Additional Charges</h5>
                <span class="read-only-badge" *ngIf="isReadOnly">🔒 Read only</span>
              </div>
            </div>
  
            <div class="section-body">
  
              <!-- Saved charges — shown in every mode -->
            <div class="info-banner" *ngIf="savedCharges.length === 0 && !savedChargesLoading">
                💰 No additional charges{{ isReadOnly ? '' : ' added yet.' }}
            </div>
            
            <div class="saved-section-label" *ngIf="savedCharges.length > 0">
                <span>💰</span> Saved Charges
            </div>
            
            <div class="repeatable-block saved-charge-card" *ngFor="let sc of savedCharges; let i = index">
                <div class="saved-charge-top">
                <span class="saved-charge-name">{{ sc.chargeTypeName }}</span>
                <span class="charge-index-badge">{{ i + 1 }}</span>
                </div>
            
                <div class="saved-charge-date" *ngIf="sc.chargeDate || sc.createdAt">{{ formatApiDate(sc.chargeDate || sc.createdAt) }}</div>
            
                <div class="charge-chip-row">
                <div class="charge-chip chip-customer" *ngIf="sc.chargeToCustomer">
                    <span class="chip-label">Customer</span>
                    <span class="chip-amount">₹{{ sc?.charge | number:'1.0-0':'en-IN' }}</span>
                </div>
                <div class="charge-chip chip-vendor" *ngIf="sc.chargeToVendor">
                    <span class="chip-label">Vendor</span>
                    <span class="chip-amount">₹{{ sc?.vendorCharge | number:'1.0-0':'en-IN' }}</span>
                </div>
                </div>
            
                <div class="form-grid" *ngIf="sc.remarks">
                <div class="form-field full">
                    <label>Remarks</label>
                    <input type="text" class="form-control" [value]="sc.remarks" readonly />
                </div>
                </div>
            
                <div class="saved-charge-footer">
                <span class="doc-empty" *ngIf="!sc.docUrl">No document attached</span>
                <a class="doc-link-icon" *ngIf="sc.docUrl" [href]="sc.docUrl" target="_blank" rel="noopener" title="View document">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                    </svg>
                    View Document
                </a>
                </div>
            </div>
  
              <!-- Charge form rows — hidden entirely in read-only mode.
                   There is a SINGLE common footer with "+ Add More" and
                   "Save Charges" for the whole block — individual rows no
                   longer have their own save button. Save Charges saves
                   every not-yet-saved row in one go. -->
              <ng-container *ngIf="!isReadOnly">
                <div class="repeatable-block charge-entry-row" *ngFor="let charge of charges; let ci = index">
                  <div class="repeatable-header">
                    <span class="repeatable-title">Add Charge {{ charges.length > 1 ? (ci + 1) : '' }}</span>
                    <span class="d-flex align-items-center gap-2">
                      <span class="badge badge-green" *ngIf="charge.saved">✓ Saved</span>
                      <button
                        type="button"
                        class="charge-entry-remove"
                        *ngIf="charges.length > 1 && !charge.saved"
                        (click)="removeCharge(ci)">
                        ❌
                      </button>
                    </span>
                  </div>
  
                  <div class="form-grid">
                    <div class="form-field">
                      <label>Type</label>
                      <select class="form-control editable" [(ngModel)]="charge.chargeTypeId" (change)="onChargeTypeChange(charge, $event)">
                        <option [ngValue]="null" disabled>Select</option>
                        <option *ngFor="let ct of chargeTypeList" [ngValue]="ct.id">{{ ct.name || ct.chargeName }}</option>
                      </select>
                    </div>
                    <div class="form-field">
                      <label>Amount (₹) <span class="required">*</span></label>
                      <input type="text" appIndianNumberFormat class="form-control editable" [(ngModel)]="charge.charge" placeholder="0" />
                    </div>
                  </div>
  
                  <div class="form-grid">
                    <div class="form-field">
                      <label>Document <span class="optional-label">(optional)</span></label>
                      <div class="file-upload-row">
                        <label class="file-upload-btn">
                          📎 Choose File
                          <input type="file" hidden accept="image/*,.pdf" (change)="onChargeFileSelected($event, charge)" />
                        </label>
                        <span class="file-upload-status" *ngIf="charge.uploading">Uploading...</span>
                        <span class="file-upload-status success" *ngIf="!charge.uploading && charge.docUrl">✓ {{ charge.docUrl.split('/').pop() }}</span>
                        <span class="file-upload-status" *ngIf="!charge.uploading && !charge.docUrl">No file chosen</span>
                      </div>
                    </div>
                    <div class="form-field">
                      <label>Remarks <span class="optional-label">(optional)</span></label>
                      <input type="text" class="form-control editable" [(ngModel)]="charge.remarks" placeholder="Optional" />
                    </div>
                  </div>
  
                  <!-- Charge Allocation -->
                  <div class="radio-group">
                    <label class="radio-label">Charge Allocation <span class="required">*</span> — both can be selected if applicable</label>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input type="checkbox" [(ngModel)]="charge.chargeToCustomer" /> Charged to Customer
                      </label>
                      <label class="radio-option">
                        <input type="checkbox" [(ngModel)]="charge.chargeToVendor" /> Paid to Vendor
                      </label>
                    </div>
                  </div>
  
                  <!-- Vendor Charge — only when Paid to Vendor is checked -->
                  <div class="form-grid" *ngIf="charge.chargeToVendor">
                    <div class="form-field">
                      <label>Vendor Charge (₹) <span class="required">*</span></label>
                      <input type="number" class="form-control editable" [(ngModel)]="charge.vendorCharge" placeholder="0" />
                    </div>
                  </div>
                </div>

                <!-- Common footer for the whole Additional Charges block -->
                <div class="charges-common-footer">
                  <button type="button" class="btn btn-outline" (click)="addAnotherCharge()">
                    + Add More
                  </button>
                  <button type="button" class="btn btn-purple" [disabled]="chargesSaving" (click)="saveAllCharges()">
                    {{ chargesSaving ? 'Saving...' : 'Save Charges' }}
                  </button>
                </div>
              </ng-container>
  
            </div>
          </div>
          
          <div class="card-section" *ngIf="isTripEnded">
            <div class="section-header">
              <span class="step-badge">🚩</span>
              <h5>Trip Ended</h5>
              <span class="read-only-badge">🔒 Read only</span>
            </div>
          
            <div class="section-body">
              <div class="info-banner">
                💬 <span *ngIf="tripData?.remarks">{{ tripData?.remarks }}</span>
                <span *ngIf="!tripData?.remarks">No remarks added</span>
              </div>
            </div>
          </div>

          <!-- ══════════════════════════════════════
               CLOSE TRIP
          ══════════════════════════════════════ -->
          <ng-container *ngIf="!isReadOnly && hasRole('ROLE_OPERATION')">
  
            <div class="info-banner" *ngIf="!canCloseTrip()">
              💡 <b>To close this trip, you need:</b> at least one saved POD
            </div>
  
            <div class="bottom-bar" *ngIf="canCloseTrip()">
              <button type="button" class="btn btn-purple" (click)="openEndTripModal()">
                🚩 End Trip
              </button>
            </div>
  
          </ng-container>
  
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════
     End Trip — comment confirmation modal
══════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="showEndTripModal" (click)="cancelEndTripModal()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5>End Trip</h5>
      <span class="lhc-section-icon cursor-pointer" (click)="cancelEndTripModal()">❌</span>
    </div>

    <div class="modal-body">
      <div class="form-field full">
        <label>Comment <span class="required">*</span></label>
        <textarea
          class="form-control editable"
          rows="3"
          [(ngModel)]="endTripRemarks"
          placeholder="Add a remark before ending this trip..."></textarea>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline" (click)="cancelEndTripModal()">Cancel</button>
      <button
        type="button"
        class="btn btn-purple"
        [disabled]="closingTrip || !endTripRemarks?.trim()"
        (click)="confirmCloseTrip()">
        {{ closingTrip ? 'Closing...' : 'Confirm & End Trip' }}
      </button>
    </div>
  </div>
</div>